/* eslint-disable no-prototype-builtins */
import { api as $axios } from '@/helpers/interceptors'
import {
  GET_CAMPAIGN_LIST,
  GET_CAMPAIGN_CONTENT,
  CREATE_CAMPAIGN,
  GET_CAMPAIGN_PRE_REGISTER,
  UPDATE_CAMPAIGN_CONTENT,
  GET_CAMPAIGN_DETAIL,
  CREATE_CAMPAIGN_PRODUCT,
} from '@/constants/path'
import snakeCaseKeys from 'snakecase-keys'
// import router from '@/router'
import { meta } from '@/config/pagination'
import { DELIVERY_TYPE } from '@/enums/campaign.enum'
import dayjs from '@/helpers/dayjs'

export const defaultCampaignMeta = () => ({
  title: '',
  description: '',
  keywords: '',
  ogTitle: '',
  ogDescription: '',
  ogImage: '',
  canonical: '',
  robots: '',
})

export const defaultFromCampaign = {
  name: '',
  slug: '',
  startedAt: null,
  endedAt: null,
  isDeliveryHome: 0,
  isDeliveryStore: 0,
  shipdate: null,
  banner: null, // for html
  bannerCta: null, // url
  stickyBanner: null, // url
  conditionHtml: null, // for html
  countdownHtml: null, // for html
  type: null, // for html
  stickyLink: null,
  additionalProduct: {
    id: null,
    products: [],
  },
  isDeliveryHomeAndIsDeliveryStore: [],
  preregisFooterHtml: null,
  preregisPreviewHtml: null,
  forceCoupon: null,
  depositMsg: null,
  htmlAfterStart: null,
  customFieldOnCart: 0,
  paymentTypes: null,
  ignoreItec: 0,
  showWarrantyOnDeposit: 0,
  showWarrantyOnFullpayPickup: 0,
  showWarrantyOnFullpayDelivery: 0,
  showWarrantyOnStockcard: 0,
  stockCardTitle: null,
  stockCardHtml: null,
  isCanPayAtStore: 0,
  isCanPayOnline: 0,
  meta: defaultCampaignMeta(),
}

const consentPath = (campaignId) =>
  `${GET_CAMPAIGN_LIST}/${campaignId}/consents`

const state = () => ({
  data: [],
  campaignDetail: null,
  campaignContent: null,
  campaignPreRegister: [],
  campaignDropdown: [],
  metaCampaignDropdown: meta,
  isError: false,
  isLoading: false,
  formCampaign: defaultFromCampaign,
  meta,
  metaPreRegister: meta,
  selectTab: 0,
  loadingDetail: false,
  loadingDownloadFile: false,
})

// getters
const getters = {}

// actions
const actions = {
  async getCampaignList({ commit }, params) {
    commit('SET_LOADING', true)
    try {
      params = JSON.parse(JSON.stringify(params))
      if (params.type === 'ทั้งหมด') delete params.type

      const res = await $axios(
        `${GET_CAMPAIGN_LIST}`,
        'get',
        snakeCaseKeys({
          params,
        }),
      )
      commit('SET_DATA', res?.data?.data)
      commit('SET_STATE', { key: 'meta', value: res?.data?.meta })

      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_DATA', null)
      commit('SET_STATE', meta)
      commit('SET_LOADING', false)

      throw error
    }
  },

  /**
   * เหมือน getCampaignList แต่เก็บใน state แยก
   * เพื่อไม่ทับรายการที่ตารางแคมเปญใช้อยู่ (state.campaign.data)
   */
  async getCampaignDropdown({ commit }, params) {
    commit('SET_LOADING', true)
    try {
      params = JSON.parse(JSON.stringify(params))
      if (params.type === 'ทั้งหมด') delete params.type

      const res = await $axios(
        `${GET_CAMPAIGN_LIST}`,
        'get',
        snakeCaseKeys({
          params,
        }),
      )

      commit('SET_STATE', {
        key: 'campaignDropdown',
        value: res?.data?.data ?? [],
      })
      commit('SET_STATE', {
        key: 'metaCampaignDropdown',
        value: res?.data?.meta ?? meta,
      })

      commit('SET_LOADING', false)

      return res?.data?.data ?? []
    } catch (error) {
      commit('SET_STATE', { key: 'campaignDropdown', value: [] })
      commit('SET_STATE', {
        key: 'metaCampaignDropdown',
        value: meta,
      })
      commit('SET_LOADING', false)

      throw error
    }
  },

  async getCampaignDetail({ commit }, id) {
    commit('SET_LOADING_DETAIL', true)
    try {
      const res = await $axios(`${GET_CAMPAIGN_DETAIL}/${id}`, 'get')
      commit('SET_STATE', {
        key: 'campaignDetail',
        value: res?.data?.data,
      })
      commit('SET_CAMPAIGN_DETAIL', res?.data?.data)
      commit('SET_LOADING_DETAIL', false)
    } catch (error) {
      commit('SET_STATE', {
        key: 'formCampaign',
        value: defaultFromCampaign,
      })
      commit('SET_LOADING_DETAIL', false)

      throw error
    }
  },

  async getCampaignContent({ commit }) {
    commit('SET_LOADING', true)
    try {
      const res = await $axios(GET_CAMPAIGN_CONTENT, 'get')
      commit('SET_CAMPAIGN_CONTENT', res?.data?.data)
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_CAMPAIGN_CONTENT', null)
      commit('SET_LOADING', false)

      throw error
    }
  },

  async getCampaignPreRegister({ commit }, query) {
    commit('SET_LOADING', true)
    try {
      let params = JSON.parse(JSON.stringify(query))
      params.campaignId = params.campaignId?.id
      const res = await $axios(
        `${GET_CAMPAIGN_PRE_REGISTER}`,
        'get',
        snakeCaseKeys({ params }),
      )
      commit('SET_CAMPAIGN_PRE_REGISTER', res?.data?.data)

      commit('SET_STATE', {
        key: 'metaPreRegister',
        value: res?.data?.meta,
      })
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_CAMPAIGN_PRE_REGISTER', null)
      commit('SET_LOADING', false)

      throw error
    }
  },
  async createCampaign({ commit }, data) {
    commit('SET_LOADING', true)
    try {
      data.is_verify_recaptcha = 0
      delete data.is_delivery_home_and_is_delivery_store
      await $axios(CREATE_CAMPAIGN, 'post', data)
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_LOADING', false)
      throw error
    }
  },
  async createCampaignProduct({ commit }, data) {
    commit('SET_LOADING', true)
    try {
      await $axios(CREATE_CAMPAIGN_PRODUCT, 'post', data)
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_LOADING', false)
      throw error
    }
  },

  // eslint-disable-next-line no-empty-pattern
  async editCampaign({}, data) {
    // eslint-disable-next-line no-useless-catch
    try {
      delete data.is_delivery_home_and_is_delivery_store
      await $axios(
        `${CREATE_CAMPAIGN}/${data.id}`,
        'put',
        snakeCaseKeys({ ...data, is_verify_recaptcha: 0 }),
      )
    } catch (error) {
      throw error
    }
  },

  async updateCampaignContent({ commit }, payload) {
    commit('SET_LOADING', true)
    try {
      if (payload) {
        await $axios(
          UPDATE_CAMPAIGN_CONTENT,
          'post',
          snakeCaseKeys(payload),
        )
      }
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_LOADING', false)
      throw error
    }
  },

  /**
   * รายการ consent ที่ active ของแคมเปญ เรียงตาม sort_order มาจาก API แล้ว
   * ไม่เก็บลง state เพราะเป็น draft ที่ component แก้หลายรอบก่อน PUT ครั้งเดียว
   * ไม่ try/catch — GET ไม่ถูก toast จาก interceptors จึงปล่อยให้ component
   * รับ error ไปแสดง alert + ปุ่มลองใหม่เอง
   */
  // eslint-disable-next-line no-empty-pattern
  async getCampaignConsents({}, campaignId) {
    const res = await $axios(consentPath(campaignId), 'get')

    return res?.data?.data ?? []
  },

  /**
   * แทนที่รายการ consent ทั้งหมดของแคมเปญ ไม่ใช่ partial update
   * ต้องส่งทุกข้อทุกครั้ง ลำดับใน array คือลำดับที่แสดง และ [] = ลบทั้งหมด
   * ห้ามส่ง id / sort_order (server จัดการเอง แก้ฟิลด์ = สร้างเวอร์ชันใหม่)
   * response ของ put ไม่ถูก camelCase จึงไม่เอามาใช้
   * ให้ component ยิง getCampaignConsents ใหม่หลังบันทึก
   */
  // eslint-disable-next-line no-empty-pattern
  async updateCampaignConsents({}, { campaignId, consents }) {
    await $axios(
      consentPath(campaignId),
      'put',
      snakeCaseKeys({ consents: consents ?? [] }),
    )
  },

  setSelectTab({ commit }, payload) {
    commit('SET_STATE', { key: 'selectTab', value: payload })
  },

  reset({ commit }) {
    commit('SET_STATE', {
      key: 'formCampaign',
      value: defaultFromCampaign,
    })
    commit('SET_STATE', { key: 'campaignDetail', value: null })
    commit('SET_STATE', { key: 'campaignContent', value: null })
    commit('SET_STATE', { key: 'campaignPreRegister', value: [] })
    commit('SET_STATE', { key: 'meta', value: meta })
    commit('SET_STATE', { key: 'metaPreRegister', value: meta })
    commit('SET_STATE', { key: 'selectTab', value: 0 })
  },

  // eslint-disable-next-line no-empty-pattern
  async delete({}, id) {
    // eslint-disable-next-line no-useless-catch
    try {
      await $axios(`${CREATE_CAMPAIGN}/${id}`, 'delete')
    } catch (error) {
      throw error
    }
  },
  async downloadPreregister({ commit }, query) {
    try {
      commit('SET_STATE', { key: 'loadingDownloadFile', value: true })
      let params = JSON.parse(JSON.stringify(query))
      params.campaignId = query.campaignId?.id
      await $axios(
        `${GET_CAMPAIGN_PRE_REGISTER}/export`,
        'get',
        snakeCaseKeys({ params }),
      ).then((response) => {
        const blob = new Blob([response.data], {
          type: 'text/csv;charset=utf-8',
        })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `ลงทะเบียนล่วงหน้า`
        link.click()
        URL.revokeObjectURL(link.href)
      })
      commit('SET_STATE', {
        key: 'loadingDownloadFile',
        value: false,
      })
    } catch (e) {
      commit('SET_STATE', {
        key: 'loadingDownloadFile',
        value: false,
      })
      return new Error(e)
    }
  },
}

// mutations
const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
  SET_LOADING_DETAIL(state, payload) {
    state.loadingDetail = payload
  },
  SET_DATA(state, payload) {
    state.data = payload
  },
  SET_CAMPAIGN_CONTENT(state, payload) {
    state.campaignContent = payload
  },
  SET_CAMPAIGN_PRE_REGISTER(state, payload) {
    state.campaignPreRegister = payload
  },
  SET_CAMPAIGN_DETAIL(state, payload) {
    let form = {}
    let delivery = []
    if (payload.isDeliveryHome) delivery.push(DELIVERY_TYPE.DELIVERY)
    if (payload.isDeliveryStore) delivery.push(DELIVERY_TYPE.STORE)

    form = {
      id: payload.id,
      name: payload.name,
      slug: payload.slug,
      startedAt: dayjs
        .utc(payload.startedAt)
        .local()
        .format('YYYY/MM/DD HH:mm'),
      endedAt: dayjs
        .utc(payload.endedAt)
        .local()
        .format('YYYY/MM/DD HH:mm'),

      isDeliveryHome: payload.isDeliveryHome ? 1 : 0,
      isDeliveryStore: payload.isDeliveryStore ? 1 : 0,
      shipdate: payload.shipdate,
      // dayjs(payload.shipdate).format('YYYY-MM-DD') ===
      // 'Invalid Date'
      //   ? null
      //   : dayjs(payload.shipdate).format('YYYY-MM-DD'),
      banner: payload.banner, // for html
      bannerCta: payload.bannerCta, // url
      imgBelowCartDep: payload.imgBelowCartDep, // url
      imgBelowCartFull: payload.imgBelowCartFull, // url
      linkBelowCart: payload.linkBelowCart, // url
      stickyBanner: payload.stickyBanner, // url
      conditionHtml: payload.conditionHtml, // for html
      countdownHtml: payload.countdownHtml, // for html
      type: payload.type, // for html
      additionalProducts: payload.additionalProduct ?? {
        id: null,
        products: [],
      },
      stickyLink: payload.stickyLink,
      stockRatio: payload.stockRatio,
      isDeliveryHomeAndIsDeliveryStore: delivery,
      priority: payload.priority,
      btnDeposit: payload.btnDeposit,
      btnFullStaff: payload.btnFullStaff,
      btnFullCustomer: payload.btnFullCustomer,
      preregisPreviewHtml: payload.preregisPreviewHtml,
      preregisFooterHtml: payload.preregisFooterHtml,
      visible: payload.visible,
      imgMailPromo: payload.imgMailPromo,
      imgMailComplete: payload.imgMailComplete,
      forceCoupon: payload.forceCoupon,
      depositMsg: payload.depositMsg,
      htmlAfterStart: payload.htmlAfterStart,
      customFieldOnCart: payload.customFieldOnCart,
      paymentTypes: payload.paymentTypes,
      ignoreItec: payload.ignoreItec ? 1 : 0,
      showWarrantyOnDeposit: payload.showWarrantyOnDeposit ? 1 : 0,
      showWarrantyOnFullpayPickup: payload.showWarrantyOnFullpayPickup
        ? 1
        : 0,
      showWarrantyOnFullpayDelivery:
        payload.showWarrantyOnFullpayDelivery ? 1 : 0,
      showWarrantyOnStockcard: payload.showWarrantyOnStockcard
        ? 1
        : 0,
      stockCardTitle: payload.stockCardTitle,
      stockCardHtml: payload.stockCardHtml,
      isCanPayAtStore: payload.isCanPayAtStore ? 1 : 0,
      isCanPayOnline: payload.isCanPayOnline ? 1 : 0,
      // meta เป็น null ได้ทั้งก้อน และ key ที่ไม่ได้ตั้งค่าจะไม่มีอยู่ใน object
      meta: { ...defaultCampaignMeta(), ...(payload.meta ?? {}) },
    }

    state.formCampaign = form
  },
  SET_STATE(state, ops) {
    state[ops.key] = ops.value
  },
  PUSH_ADDITIONAL_PRODUCT(state) {
    state.formCampaign.additionalProduct.products.push({
      groupName: null,
      products: [],
    })
  },
  REMOVE_ADDITIONAL_PRODUCT(state, index) {
    state.formCampaign.additionalProduct.products.splice(1, index)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
